{
  "title": "讀懂審查進度與利益衝突警示",
  "description": "了解「審查進度」頁的負載表格、啟發式旗標，以及利益衝突重疊警示的「重新指派」與「僅取消指派」兩種處理方式。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "畫面說明", "完成後", "常見問題"],
  "summary": "看完後，您能正確解讀每位評審的負載數字與旗標含義，並知道如何直接在本頁重新指派或取消一筆有利益衝突重疊的指派。",
  "roleNote": "競賽管理員／具評審治理權限的工作人員",
  "prerequisites": ["競賽已建立", "已邀請並指派至少一位評審"],
  "pathLabel": "主辦方後台 → 我的競賽 → 審查 → 審查進度",
  "steps": [
    {
      "title": "1. 審查進度表格",
      "description": "「審查進度」頁（URL 仍是 /judging-load，僅畫面標籤由「評審負載」更名）提供每位評審的負載表格，欄位含姓名／Email、邀請狀態、已指派件數、已完成件數、待評件數、已申報衝突數、最近活動時間，以及旗標欄。"
    },
    {
      "title": "2. 啟發式旗標",
      "description": "旗標欄可能顯示「工作量過重」「指派不足」「近期無活動」，判斷門檻（倍數與無活動天數）皆由系統設定並顯示於表格上方。這些旗標僅為操作提示，用於協助您判斷是否需要調整指派，並非對特定評審表現的評斷。"
    },
    {
      "title": "3. 利益衝突重疊警示",
      "description": "頁面下方「利益衝突」清單，會比對每位評審已申報的利益衝突與目前進行中的作品指派，找出「已宣告迴避但仍持有相同作品進行中指派」的異常組合；清單欄位含評審、隊伍、申報原因、申報來源（評審自行申報或人工登記）。"
    },
    {
      "title": "4. 重新指派（主要動作）",
      "description": "利益衝突重疊清單的每一列提供「重新指派」為主要動作：點擊後從下拉選單選擇一位新評審（會自動排除目前這位有衝突的評審），確認送出後，系統會先對新評審重新驗證利益衝突，通過才會建立新指派並移除原本重疊的舊指派；全程不需要離開本頁或前往「作品指派」分頁。"
    },
    {
      "title": "5. 僅取消指派（次要動作）",
      "description": "若暫時不指定替代評審，可改用「僅取消指派」：需填寫取消原因，確認後該筆重疊指派轉為已取消狀態，之後可自行前往「作品指派」分頁另行指派。"
    },
    {
      "title": "6. 提醒評審完成評分",
      "description": "頁面上方的「提醒評審完成評分」列出仍有未送出評分的評審與其未完成件數（已申報利益迴避的作品不計入）。具評審管理權限者可點「寄送提醒給未完成的評審」，先預覽信件內容（以第一位評審為例），確認後寄出；信中含未完成件數、最近的審查截止時間與前往評審任務的連結。每次寄送會記錄一筆稽核，不會修改任何評分或指派。頁面上方的「截止前自動提醒評審」開關（預設關閉）開啟後，系統會在每個輪次審查截止前的指定小時數，自動對仍有未送出評分的評審各寄一次提醒（每輪只寄一次）。"
    },
    {
      "title": "7. 評審自行退出",
      "description": "評審若臨時無法擔任，可在自己的評審任務頁填寫原因後退出，其尚未送出評分的指派會被取消並留下稽核紀錄。您會在本頁看到該評審的指派件數下降，請到「作品指派」分頁重新指派這些作品。"
    }
  ],
  "afterward": [
    "可依旗標提示評估是否需要重新分配指派",
    "使用「重新指派」時，新指派會立即生效，原重疊指派同步移除，不需額外步驟",
    "使用「僅取消指派」時，該筆指派轉為已取消，需另外前往「作品指派」分頁指派替代評審"
  ],
  "nextSteps": "若使用「重新指派」，處理已在本頁完成；若使用「僅取消指派」，請前往「作品指派」分頁，將該作品指派給沒有利益衝突的評審。",
  "faq": [
    {
      "q": "「工作量過重」的判斷標準是什麼？",
      "a": "門檻並非寫死的固定數字，而是依系統設定的倍數與無活動天數計算，實際數值會顯示在負載表格上方的說明文字中。旗標僅為操作提示，不代表對評審的評斷。"
    },
    {
      "q": "利益衝突重疊清單裡的「重新指派」會不會又指派到另一位有衝突的評審？",
      "a": "不會。送出前系統會針對您選擇的新評審重新驗證一次利益衝突；若新評審與該作品／隊伍同樣有已申報的衝突，系統會拒絕這次重新指派並顯示原因，您需要改選其他評審。"
    },
    {
      "q": "「重新指派」和「僅取消指派」該選哪一個？",
      "a": "已經知道要換給誰，直接用「重新指派」一步完成最快；若還不確定替代人選，可先用「僅取消指派」把有問題的指派移除，稍後再到「作品指派」分頁從容挑選評審。"
    }
  ]
}
